export const CHECKS = [
    <>Дополнительное образование по&nbsp;длительной программе психотерапии (от&nbsp;500&nbsp;ч)</>,
    <>
        Уровень эмпатии и&nbsp;этические принципы, которыми специалист руководствуется в&nbsp;работе
    </>,
    <>Посещал&nbsp;ли специалист личного психолога сам не&nbsp;менее года</>,
    <>Успешные кейсы по&nbsp;заявленным специализациям</>,
    <>Есть&nbsp;ли у&nbsp;него не&nbsp;менее 50&nbsp;часов супервизии</>,
    <>Знания о&nbsp;работе и&nbsp;устройстве психики</>,
]
